import { h, Component } from 'preact';
import linkState from 'linkstate';
import cx from 'classnames';

import { ModalProps, Modal } from '../common/modal';
import { Remittance } from '../../../../types/remittance.model';
import { Subject, Subscription } from 'rxjs';
import getStore, { appState$ } from '../../store';
import { map } from 'rxjs/operators';

import { RequestState, REQUEST_IN_PROGRESS, REQUEST_SUCCESS } from '../../../../types/request-state.model';
import { FieldList, Field, Form } from '../../../../types/form.model';
import { validateForm, cxValidateField } from '../../../../types/validator.model';
import * as Validators from '../../../../types/validator.model';
import linkform from '../../../utils/linkform';
import { CREATE_BANK_ACCOUNT, UserAction, GET_BANKS, CREATE_USER, CHANGE_PASSWORD } from '../../reducers/user/user.actions';
import { User } from '../../../../types/user.model';

export interface ChangePasswordModalProps extends ModalProps {
  selectedUser: User;
}

interface ChangePasswordModalState  {

  submitStatus?: RequestState;
  form?: Form;
}

export class ChangePasswordModal extends Modal<ChangePasswordModalProps, ChangePasswordModalState> {
  subs: Subscription[] = [];
  form$: Subject<Form>;

  constructor(props: ChangePasswordModalProps) {
    super(props);

    this.createForm();
  }

  createForm() {
    let fields: FieldList = {
      'password': new Field([Validators.required] , null, ''),
    };

    this.form$ = new Subject<Form>();
    this.setState({
      form: new Form(fields)
    });

    this.form$.subscribe((form) => {
      validateForm(form);

      let state = {};
      state['form'] = form;
      this.setState(state);
    });
  }

  componentDidMount() {
    super.componentDidMount();

    const user$ = appState$.pipe(
      map(app => app.user)
    );

    this.subs.push(
      user$.pipe(
        map(user => user.changePasswordStatus)
      ).subscribe(reqState => {
        this.setState({
          submitStatus: reqState
        });

        if (reqState === REQUEST_SUCCESS) {
          this.doModalClose();
        }
      })
    );

    this.initialStoreDispatches();
  }

  initialStoreDispatches() {

    const store = getStore();

  }

  componentWillUnmount() {
    this.subs.forEach(s => s.unsubscribe());
  }

  doModalClose = () => {
    this.props.close();
  }

  getSpinnerBlock(state: ChangePasswordModalState) {
    if (state.submitStatus === REQUEST_IN_PROGRESS) {
      return (
        <div class="col offset-md-9 d-flex justify-content-end">
          <div class="spinner-border text-primary mt-3" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      );
    }    
  }

  onSubmit = () => {

    let form = this.state.form;

    validateForm(form);

    if (!form.isValid) {
      return;
    }

    let user: User = {
      username: this.props.selectedUser.username,
      password: form.fields['password'].value,
    }

    const store = getStore();
    store.dispatch({
      type: CHANGE_PASSWORD,
      payload: {
        userToUpdate: user
      }
    });
  }

  render(props: ChangePasswordModalProps, state: ChangePasswordModalState) {
    let form = state.form;

    return (
      <div class="container anglo-modal"
          ref={ node => this.refNode = node }>
        <div class="row anglo-modal__head align-items-center">
          <div class="col-9 col-md-10">
            <h3 class="mb-0">
              Change password | <small>{ props.selectedUser.username }</small>
            </h3>
          </div>
          <div class="col-3 col-md-2">
            <button class="btn btn-outline-light w-100" onClick={this.doModalClose}>
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
        
        <div class="row anglo-modal__body py-3">

          <p class="col-12">
            Note: This is a force reset of an existing password.
          </p>

          <div class="col-12 mt-2">
            <label class="dash-remittance__filter-row__filters__label">New Password*</label>
            <input type="text" className={ cx('form-control', 
              { 'invalid': cxValidateField(form.fields['password']) }
            )}
            value={ form.fields['password'].value }
            placeholder=""
            onChange={ linkform(this.form$, form, 'password') }/>
          </div>

          <div class="col-2 offset-8 mt-4">
            {
              this.getSpinnerBlock(state)
            }
          </div>

          <div class="col-2 mt-4">

            <button class="btn btn-primary w-100" onClick={this.onSubmit}>
              Submit
            </button>
          </div>
        </div>

        
      </div>
    );
  }
}